import React, { Component } from 'react';
import { connect } from 'react-redux';
import {TextField, Grid, Chip, IconButton, Box} from '@material-ui/core';
import { isEmpty, isUndefined } from 'lodash';
import { fade, withStyles, darken } from '@material-ui/core/styles';
import RemoveIcon from '@material-ui/icons/HighlightOff'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({ArtikelReg}) {
    const { ArtikelTagsList } = ArtikelReg;
    return {
      ArtikelTagsList
    };
}
function mapDispatchToProps(dispatch) {
    return {
      
    };
}

const styles = theme => ({
  badgeRoot: {
    fontSize: 14,
    letterSpacing: 0.5,
    borderRadius: 4,
    padding: '2px 12px',
    marginRight: 5,
    marginBottom: 5,
    fontWeight: 500,
    display: 'inline-block'
  },
});

class ArtikelTagg extends Component {
  
  onChangeHandle=(e)=>{
    try {
      let taggar = JSON.parse(this.props.tagsJSON)
      if(isUndefined(taggar.find(t => t === parseInt(e.target.value)))) taggar.push(parseInt(e.target.value))
      this.props.setTagsJSON(JSON.stringify(taggar))
    } catch (err) {}
  }
  removeTag=(id) => {
    try {
      let taggar = JSON.parse(this.props.tagsJSON)
      taggar = taggar.filter(t => t !== id)
      this.props.setTagsJSON(JSON.stringify(taggar))
    } catch (err) {}
  }
  returnTags = () => {
    try {
      let taggar = JSON.parse(this.props.tagsJSON)
      return taggar
    } catch (err) { return []}
  }
  render() {
       return (
        <Grid item xs="12">
                {
                    isEmpty(this.props.ArtikelTagsList)?"":
                
                    <TextField
                    variant="outlined"
                    fullWidth
                    className='mb-1'
                    label={<IntlMessages id="Input.Tagg.label"/>}
                    size="small"
                    name="type"
                    select
                    value={0}
                    SelectProps={{native: true,}}
                    InputLabelProps={{shrink: true,}}
                    onChange={this.onChangeHandle}
                  >
                    <option Key="0" value={0}><IntlMessages id="Choose"/></option>
                {
                this.props.ArtikelTagsList.map((option,index) => (
                  <option key={index} value={option.id}>
                    {option.Keyword}
                  </option>
                ))}
            </TextField>  
            }
            {
              this.returnTags().map(t => {
                let tagg = this.props.ArtikelTagsList.find(tag => tag.id === t)
                if(isUndefined(tagg)) return ''
                return (
                  <Box
                    component="span"
                    className={this.props.classes.badgeRoot}
                    style={{
                      backgroundColor: fade(tagg.Color, 0.2),
                      color: darken(tagg.Color, 0.2),
                    }}>
                    {tagg.Keyword}
                    <IconButton size="small" style={{height: 16, width: 16}} onClick={()=>this.removeTag(tagg.id)}>
                      <RemoveIcon style={{fontSize:18, marginLeft: 5, color: tagg.Color}}/>
                    </IconButton>
                  </Box>
                )
                // <Chip className={'mr-1 mb-1'} size="small" style={{backgroundColor: tagg.Color, color:'white'}} label={tagg.Keyword} onDelete={()=>this.removeTag(tagg.id)}/>
              })
            }
            </Grid>
        );
    }
}

export default connect(
    mapStateToProps,
)(withStyles(styles, { withTheme: true })(ArtikelTagg));